// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { SurveyInfoResponseDTO } from "../../api/backend-openapi";

export const setSurveys = createEvent<SurveyInfoResponseDTO[]>("SET_SURVEYS");
export const addSurvey = createEvent<SurveyInfoResponseDTO>("ADD_SURVEY");
export const deleteSurvey = createEvent<string>("DELETE_SURVEY");
export const updateSurvey = createEvent<SurveyInfoResponseDTO>("UPDATE_SURVEY");
